import { render } from "./CreateReminderModal.vue?vue&type=template&id=1eaddfe0"
import script from "./CreateReminderModal.vue?vue&type=script&lang=js"
export * from "./CreateReminderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/modals/CreateReminderModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1eaddfe0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1eaddfe0', __exports__)) {
    api.reload('1eaddfe0', __exports__)
  }
  
  module.hot.accept("./CreateReminderModal.vue?vue&type=template&id=1eaddfe0", () => {
    api.rerender('1eaddfe0', render)
  })

}


export default __exports__